import { render, staticRenderFns } from "./BusinessOpportunityAnalysis.vue?vue&type=template&id=20c24272&scoped=true"
import script from "./BusinessOpportunityAnalysis.vue?vue&type=script&lang=js"
export * from "./BusinessOpportunityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BusinessOpportunityAnalysis.vue?vue&type=style&index=0&id=20c24272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c24272",
  null
  
)

export default component.exports